import React, { useState } from 'react';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import step1Img from '../../../../assets/images/tour/guardian-step-one.svg';
import lastImg from '../../../../assets/images/tour/last_step.svg';
import settingsImg from '../../../../assets/images/tour/Settings.svg';
import publicRoomImg from '../../../../assets/images/tour/public_room.svg';
import connectCampImg from '../../../../assets/images/tour/connect_camp.svg';
import changePlanImg from '../../../../assets/images/tour/change_plan.svg';
import challengeProgressImg from '../../../../assets/images/tour/challenges_progress.svg';
import kidsDropdownImg from '../../../../assets/images/tour/kids_dropdown.svg';
import addKidImg from '../../../../assets/images/tour/add_kid.svg';
import KidEventImg from '../../../../assets/images/tour/kid_events_dropdown.svg';
import KidCreativeCampImg from '../../../../assets/images/tour/kid_creative_camp.svg';
import KidDreamCampImg from '../../../../assets/images/tour/kid_dream_camp.svg';
import KidNotesImg from '../../../../assets/images/tour/kid_notes.svg';
import KidPromiseImg from '../../../../assets/images/tour/kid_promise.svg';
import './customTourStyles.css'; // You'll define custom styles here
import { useMediaQuery, useTheme } from '@mui/material';
import { useRecoilState } from 'recoil';
import {
  currentStepsAtom,
  stepsEnabledAtom,
} from '../../../../atoms/camp.atom';

const GuardianTour = () => {
  const [currentStep, setCurrentStep] = useRecoilState(currentStepsAtom); // Track the current step
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const steps = [
    {
      element: '#guardian-step-one',
      intro: `
        <div class="custom-tour-step">
          <img src="${step1Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Welcome to Your Guardian Dashboard!</h3>
          <p>Here, you can easily manage your child’s TaleTree experience.</p>
          <p>From viewing their creations and tracking their challenges, to monitoring their emotional well-being and thoughts, everything you need is at your fingertips.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
    {
      element: '#guardian-step-one',
      intro: `
        <div class="custom-tour-step">
          <img src="${step1Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Use this dashboard to:</h3>
          <ul style="list-style-type: none; padding-left: 0;">
            <li style="padding-top: 10px">✏️  Edit your account details.</li>
            <li>⛺  Stay connected with your child’s camp.</li>
            <li>✅  Upgrade your plan for added features.</li>
            <li>🕹️  Toggle between profiles if you have multiple kids. </li>
            <li>🧒  Add new children to your account.</li>
            <li style="padding-bottom: 0">📈  Keep track of upcoming camps and receive reminders.</li>
          </ul>
          <p>We’re here to support you in nurturing your child’s creativity and growth every step of the way!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip guardian-step-two',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-three',
      intro: `
        <div class="custom-tour-step">
          <img src="${settingsImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Edit Account Details</h3>
          <p>Click here to update your personal information, password, and account preferences.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-four',
      intro: `
        <div class="custom-tour-step">
          <img src="${publicRoomImg}" alt="Camp Master" class="tour-avatar" />
          <h3>View Public Room</h3>
          <p>Where you can explore your child creations and see all the active challenges.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-five',
      intro: `
        <div class="custom-tour-step">
          <img src="${connectCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Send an Invite Code to a Camp</h3>
          <p>Request an invite code to connect to your child’s camp and participate in their creative journey.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-six',
      intro: `
        <div class="custom-tour-step">
          <img src="${changePlanImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Upgrade Plan</h3>
          <p>Want more features? Upgrade your plan to access additional benefits and unlock new possibilities.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-seven',
      intro: `
        <div class="custom-tour-step">
          <img src="${challengeProgressImg}" alt="Camp Master" class="tour-avatar" />
          <h3>See Challenges in Progress</h3>
          <p>Track your child’s active challenges and monitor their progress as they engage in creative activities.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-eight',
      intro: `
        <div class="custom-tour-step">
          <img src="${kidsDropdownImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Toggle Between Kids</h3>
          <p>If you have more than one child, toggle between their profiles here to view each one’s unique journey.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-nine',
      intro: `
        <div class="custom-tour-step">
          <img src="${addKidImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Add New Kids to Account</h3>
          <p>Add a new child to your account and start tracking their creativity, thoughts, and feelings.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-feelings',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidEventImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Monitor Feelings and Thoughts</h3>
          <p>Keep an eye on your child’s emotional well-being and thoughts, updated daily to provide insights into their mental state.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-creative',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidCreativeCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Stay Connected with Creative Camps</h3>
          <p>Creative Camps offer your child the chance to engage in fun, imaginative activities alongside other kids.</p>
          <p>Keep track of upcoming camps and make sure your child is ready to create and collaborate!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-dream',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidDreamCampImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Join a Dream Camp!</h3>
          <p>Dream Camps are special experiences designed to help your child explore their deepest passions and unlock their full creative potential.</p>
          <p>Stay updated on upcoming Dream Camps and encourage your child to dive in!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-notes',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidNotesImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Captain Notes</h3>
          <p>Special space to read helpful notes from Captain, guiding you on your adventures!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-step-promise',
      intro: `
        <div class="custom-tour-step">
          <img src="${KidPromiseImg}" alt="Camp Master" class="tour-avatar" />
          <h3>Commit to the 20-Minute Promise</h3>
          <p>Every week, take 20 minutes to sit with your child and discuss their thoughts, feelings, and creations.</p>
          <p>This promise helps nurture a deeper connection and fosters creativity through meaningful conversations.</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
    {
      element: '#guardian-last-step',
      intro: `
        <div class="custom-tour-step">
          <img src="${step1Img}" alt="Camp Master" class="tour-avatar" />
          <h3>Master your Dashboard!</h3>
          <p>You’re now fully equipped to explore your Guardian dashboard. Let’s create something extraordinary together at TaleTree!</p>
        </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip',
      highlightClass: 'custom-highlight',
    },
  ];

  const handleStepChange = (stepIndex) => {
    setCurrentStep(stepIndex); // Track current step
  };

  return (
    <Steps
      enabled={stepsEnabled}
      steps={steps}
      initialStep={0}
      onExit={() => setStepsEnabled(false)} // Handle exit to disable tour
      onChange={handleStepChange} // Track the current step
      options={{
        doneLabel: 'Close',
      }}
    />
  );
};

export default GuardianTour;
